import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13Z",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 14.9993V12.666",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 3.33333V1",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0003 8H12.667",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.33333 8H1",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9777 12.9777L11.2666 11.2666",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.73455 4.73357L3.02344 3.02246",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9777 3.02148L11.2666 4.73259",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.73455 11.2666L3.02344 12.9777",
			stroke: "black",
			strokeMiterlimit: 10,
			strokeLinejoin: "bevel"
		})
	]
});
export default SvgSettings;
